//Listing Builder
import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useParams, useHistory } from 'react-router-dom';

import axios from "axios";
import cloneDeep from 'lodash/cloneDeep';
import { css } from '@emotion/css';
import './slate-custom.css';
import './tiptapcustom.css';

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { v4 as uuidv4 } from 'uuid';


//Let's Try Tiptap!
import { EditorProvider, useCurrentEditor } from '@tiptap/react';
import { Editor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

import { Color } from '@tiptap/extension-color';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import ListItem from '@tiptap/extension-list-item';
import TextStyle from '@tiptap/extension-text-style';
import TextAlign from '@tiptap/extension-text-align';
import Text from '@tiptap/extension-text';
import BulletList from '@tiptap/extension-bullet-list';
import FontFamily from '@tiptap/extension-font-family';
import Paragraph from '@tiptap/extension-paragraph';
import ListKeymap from '@tiptap/extension-list-keymap';
import FontSize from '@tiptap/extension-font-size';
import Underline from '@tiptap/extension-underline';




//Let's try slate!
// Import the Slate editor factory.
//import isUrl from 'is-url';
//import imageExtensions from 'image-extensions';
//import { withHistory } from 'slate-history';
import escapeHtml from 'escape-html';
//import { Text, Transforms, Editor, Range, createEditor, Element as SlateElement, Node as SlateNode, Path } from 'slate';

import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';

import { Slider, Sketch, Material, Colorful, Compact, Circle, Wheel, Block, Github, Chrome } from '@uiw/react-color';

// Import the Slate components and React plugin.
//import { Slate, Editable, withReact, useSlate, useSlateStatic, ReactEditor, useSelected, useFocused } from 'slate-react';
//import Html from 'slate-html-serializer';
//import { jsx } from 'slate-hyperscript';



import ButtonGroup from '@mui/material/ButtonGroup';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from "@mui/icons-material/Image";
import { IconButton } from "@mui/material";
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import GridOnIcon from '@mui/icons-material/GridOn';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import GridOffIcon from '@mui/icons-material/GridOff';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadingIcon from '@mui/icons-material/Downloading';


import { useSelector, useDispatch } from 'react-redux';
import {
	setCurrentMenuSection,
	setCurrentMenuItem
} from '../../features/mainmenu/mainmenuSlice';

// //FlexDocument
// import { FlexDocument } from '../Documents/FlexDocument';

//New Error Message
import { NewErrorMessage } from '../../features/error/NewErrorMessage';
import {
	newErrorMessage,
	setErrorTimeout
} from '../../features/error/errormessageSlice';

//Contexts
import { AppContext, AppProvider } from "../Auth/contexts/AppContext";
//Error Context
//*Can be used for success as well!
//Types: ok, warning, danger, neutral
import ErrorMessage from "../common/ErrorMessage";
import { ErrorContext } from '../common/ErrorContext';

//Datetime formatting
import Moment from 'react-moment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; //Possibly our new adapter for mui x 7 datetime
import dayjs from 'dayjs'; //Used with new datetimepickers
//Restrict Numbers both float and integer types
import RestrictInputNumber from "../common/RestrictInputNumber";




import AppBar from '@mui/material/AppBar';
import MuiToolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';

import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import PaletteIcon from '@mui/icons-material/Palette';


import Checkbox from '@mui/material/Checkbox';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/GridLegacy';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

//Icons
import SaveIcon from '@mui/icons-material/Save';
import PendingIcon from '@mui/icons-material/Pending';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ViewListIcon from '@mui/icons-material/ViewList';

//Buttons
import Button from '@mui/material/Button';

//Datetime Pickers
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

//DBAutoComplete
import DBAutoComplete from '../common/DBAutoComplete';

//Printing
import { useReactToPrint } from 'react-to-print';
import FormatAlignLeft from '@mui/icons-material/FormatAlignLeft';


/* ##########################  Configuration  ########################## */
const editorTheme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#EEE',
		},
	},
});



//DB
var dbendpoint = process.env.REACT_APP_DB_API4;
var hostbase = process.env.REACT_APP_BASE;

//Default Axios Post Options
const defaultpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 60000,
};

//Axios Long Post
const longpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 20000,
};



const ListingBuilder = (props) => {
	document.title = "Listing Builder";
	const dispatch = useDispatch();
	dispatch(setCurrentMenuSection("Products"));
	dispatch(setCurrentMenuItem("/listingbuilder"));

	//URL Param for ID
	let { id } = useParams();
	
	let history = useHistory();
	//console.log(id);

	//const [editor] = useState(() => withReact(createEditor()));
	//const editor = useMemo(() => withImages(withHistory(withReact(createEditor()), [])));
	//Font support is manually added in index.html.
	const fonts = ['Arial', 'Times New Roman', 'Roboto', 'Raleway', 'Poppins', 'Montserrat', 'Inter'];

	/* App Context */
	/* Allows userperms to be used */
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;

	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	const btnSave = useRef();
	const btnPendingSave = useRef();

	const btnAddElement = useRef();

	const variantRefs = useRef([]);

	/* ##########################  UseState Variables  ########################## */
	const [state, setState] = useState({
		templateloaded: false,
		dbreload: true,
		itemdata: {
			ID: id, //I believe it may be neccessary to build out a good looking itemdata so that any DBAutoComplete instances can use the required values.
			Name: "",
			SkuDelimiter:"-",
			SkuStructure:"",
			TitleStructure:""
		},
		variantstore:[],
		productselectionkey:uuidv4()
	});


	//Clone State! We'll get the view from localstate!
	let localstate = Object.assign({}, state);
	//let localstate = {...state}; 


	function UpdateState(next) {
		setState(prev =>
		  typeof next === 'function' ? next(prev) : next
		);
	  }
	//Error Context
	const errors = useContext(ErrorContext);

	//Ref used for printing
	const printRef = useRef();

	const handlePrint = useReactToPrint({
		contentRef: printRef,
	});

	const GoToListings = () => {
		history.push('/listingtemplates');
	}


	const [currenteditor, setCurrentEditor] = useState({
		Name: "",
		modules: {
			toolbar: true
		}
	});

	const ImageUpload = (props) => {
		const [imageUrl, setImageUrl] = useState(null);
		const [error, setError] = useState(null);
		const templateindex = props.templateelement.Name.slice(-1);
		const templateroot = props.templateelement.Name.slice(0, -1);
		const onDrop = useCallback(async (acceptedFiles) => {
			try {
				const file = acceptedFiles[0];
				const url = await uploadImage(file);
				//setImageUrl(url);
				//Set localhost:
				localstate.itemdata[props.templateelement.Name] = url;
				UpdateState(localstate);
				btnSave.current.style.display = "none";
				btnPendingSave.current.style.display = "";
			} catch (err) {
				setError(err.message);
			}
		}, []);

		const onChangeContainerWidth = (event) => {
			//console.log(event);
			//console.log("Here");
			localstate.itemdata[templateroot + "Width" + templateindex] = parseInt(event.target.value);
			btnSave.current.style.display = "none";
			btnPendingSave.current.style.display = "";
		}

		const { getRootProps, getInputProps } = useDropzone({ onDrop });

		return (
			<>
				<div {...getRootProps()} style={{
					textAlign: 'center',
					cursor: 'pointer',
				}}>
					<input {...getInputProps()} />
					{localstate.itemdata[props.templateelement.Name] === "" && <div style={{ minHeight: "50px" }}><p>Place Image Here</p></div>}
					{(localstate.itemdata[props.templateelement.Name] && localstate.itemdata[props.templateelement.Name] !== "") &&
						<img src={localstate.itemdata[props.templateelement.Name]} alt="Uploaded" style={{
							maxWidth: '100%'
						}}
						/>}
					{error && <p style={{ color: "red" }}>{error}</p>}
				</div>
				<Typography variant="h6">
						<table>
						<tbody>
							<tr>
								<td style={{ width: "100px", textAlign: "right" }}>
									Width %:
								</td>
								<td>
									<input className={classes.flexiteminput} type="text" defaultValue={localstate.itemdata[templateroot + "Width" + templateindex]} onChange={(event) => onChangeContainerWidth(event)} />
								</td>
							</tr>
							
								<tr>
									<td style={{ width: "150px", textAlign: "right" }}>
										Source:
									</td>
									<td>
										<input className={classes.flexiteminput} style={{ width: "100%" }} type="text" defaultValue={localstate.itemdata[props.templateelement.Name]} onChange={(event) => onChangeValue(event, props.templateelement.Name)} />
									</td>
								</tr>
							
						</tbody>
				
				</table>
				</Typography>
			
			
			</>

		);
	};


	// Your uploadImage function
	async function uploadImage(file) {
		return new Promise(async (resolve, reject) => {
			try {
				//This gets a secure URL that we use to upload
				const foldername = dayjs().format('YYYY-MM');
				const response = await fetch(
					`https://00iojje8z6.execute-api.us-east-2.amazonaws.com/default/uploadImageFromFlex?folder=flextemplates/${foldername}`
				);
				const { uploadURL, filename } = await response.json();

				//This uploads the file
				const uploadResponse = await fetch(uploadURL, {
					method: 'PUT',
					body: file,
					headers: {
						'Content-Type': file.type,
					},
				});

				if (!uploadResponse.ok) {
					throw new Error('Upload failed');
				}
				const imageUrl = `https://deluxepcsimages.s3.amazonaws.com/${filename}`;
				resolve(imageUrl);
			} catch (error) {
				reject(error);
			}
		});
	}





	//Load Item
	function LoadTemplate() {
		const postdata = {
			ID: localstate.itemdata.ID
		};
		axios.post(dbendpoint + "/listingtemplate/getitem", postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					localstate.itemdata = res.data.item;
					// const document =  new DOMParser().parseFromString("<p>This1</p>", 'text/html');
					// localstate.itemdata.Header = deserialize(document.body); 

					//Provision to allow new pending items, but ignore the unique ID assigned by the system:
					//Do check on length later in the SaveChanges function.
					if (localstate.itemdata.PendingItem===1){
						localstate.itemdata.Name="";
					}

					localstate.templateloaded = true;
					localstate.dbreload = false;

					//Rerender Product Selection:
					localstate.productselectionkey = uuidv4();


					// //Serialize all on load - Probably no longer needed because we switched to tiptap editor
					// for (var i = 0; i < templateelements.length; i++) {
					// 	//Don't convert left side elements, they are handled by an image container, not the editor.
					// 	//console.log(templateelements[i].Name);
					// 	if (localstate.itemdata[templateelements[i].Name]) { //Cannot use includes on null values
					// 		if (!templateelements[i].Name.includes("Left") && !templateelements[i].Name.includes("HTML")) {
					// 			//localstate.itemdata[templateelements[i].Name + "HTML"] = serializeAll(localstate.itemdata[templateelements[i].Name]);
					// 		}
					// 	}
					// }

					// Sort priority order by ComponentType
					// Any new additions to this priority, check SkuIntegrationsTable, SkusTable, OrdersView, ProductsTable....
					const priorityTypes = ['CPU', 'RAM', 'Hard Drive', 'Optical', 'Resolution', 'Webcam', 'COA', 'Graphics', 'Wifi', 'Grade', 'Body Grade', 'LCD Grade'];
					if (localstate.itemdata.product !== null) {
						if (localstate.itemdata.product.hasOwnProperty('productvariants')) {




							// for (var m=0; m<localstate.ordersdata[i].orderitems[k].sku.skucomponents.length; m++){
							// 	console.log(localstate.ordersdata[i].orderitems[k].sku.skucomponents[m].details.Name);
							// }
							localstate.itemdata.product.productvariants.sort((a, b) => {
								// Determine priority of ComponentType
								const aPriority = priorityTypes.indexOf(a.ComponentType);
								const bPriority = priorityTypes.indexOf(b.ComponentType);

								// Prioritize items based on the defined priorityTypes
								if (aPriority !== -1 && bPriority === -1) return -1; // a is in priorityTypes, b is not
								if (bPriority !== -1 && aPriority === -1) return 1;  // b is in priorityTypes, a is not
								if (aPriority !== -1 && bPriority !== -1) return aPriority - bPriority; // Both in priorityTypes, sort by priority

								// If neither is in priorityTypes, sort by ComponentType alphabetically
								if (a.ComponentType < b.ComponentType) return -1;
								if (a.ComponentType > b.ComponentType) return 1;

								// If ComponentType is the same, sort alphabetically by Name
								if (a.Name < b.Name) return -1;
								if (a.Name > b.Name) return 1;

								return 0;
							});
								//On first load, we should setup default selected variants (based on product components)
							if (typeof localstate.itemdata.product.productcomponents !== undefined) {


								for (var i = 0; i < localstate.itemdata.product.productvariants.length; i++) {
									//Default the component to NOT selected
									localstate.itemdata.product.productvariants[i].Selected = false;
									//Attempt to match it to something in product components
									for (var j = 0; j < localstate.itemdata.product.productcomponents.length; j++) {
										if (localstate.itemdata.product.productvariants[i].ComponentID === localstate.itemdata.product.productcomponents[j].ComponentID) {
											localstate.itemdata.product.productvariants[i].Selected = true;
											//Create a ref
											[j] = "";
											//console.log("Match found.");
										}
									}
								}
							}
						}
					}

					//Now is a nice time to calculate variant count
					CalculateVariants();

					//localstate.itemdata.HeaderHTML = serializeAll(localstate.itemdata.Header);
					UpdateState(localstate);
				}
				if (res.data.Status === "Failure") {
					//Failure error
					localstate.dbreload = false;
					UpdateState(localstate);
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "neutral" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(15));
			}
		});
	}

	// localstate.itemdata.product.productvariants = [
	// 	{ ID: '1', ComponentType: "RAM", Name: "4GB DDR4 RAM", Selected: true },
	// 	{ ID: '2', ComponentType: "RAM", Name: "8GB DDR4 RAM", Selected: true },
	// 	{ ID: '3', ComponentType: "RAM", Name: "16GB DDR4 RAM", Selected: true },
	// 	{ ID: '4', ComponentType: "Hard Drive", Name: "256GB NVMe", Selected: true },
	// 	{ ID: '5', ComponentType: "Hard Drive", Name: "512GB NVMe", Selected: false },
	// 	{ ID: '5', ComponentType: "CPU", Name: "i7 10610", Selected: true },
	// ];

	function generateVariantCombinations(componentsByType) {
		// Get all component types (keys)
		const types = Object.keys(componentsByType);
		// Get all arrays of options, filtering for Selected and non-empty groups
		const options = types
			.map(type => componentsByType[type].filter(item => item.Selected))
			.filter(arr => arr.length > 0);
	
		// If any component type has zero selected options, no variants are possible
		if (options.length !== types.length) return [];
		// Recursive function to compute cartesian product
		function cartesianProduct(arrays, index = 0, current = {}) {
			if (index === arrays.length) {
				// Deep copy to avoid mutation
				return [JSON.parse(JSON.stringify(current))];
			}
			const type = types[index];
			const arr = arrays[index];
			let results = [];
			for (const item of arr) {
				current[type] = item;
				results = results.concat(cartesianProduct(arrays, index + 1, current));
			}
			return results;
		}
		return cartesianProduct(options);
	}

	// Or, to get just the templatenodes for each field in a variant:
	function extractTemplateNodes(variant) {
		const result = {};
		for (const type in variant) {
			result[type] = variant[type].templatenodes || [];
		}
		return result;
	}

	// Helper to extract tags from the SKU structure string
	function extractTagsFromStructure(skuStructure) {
		// Matches ${XXXX} patterns
		if (skuStructure === "" || skuStructure === null || typeof skuStructure === "undefined"){
			return [];
		} else {
			return Array.from(skuStructure.matchAll(/\$\{([A-Z0-9_]+)\}/g), m => m[1]);
		}
	}

	// Helper to find a template value for a given tag in a variant's templatenodes
	function findTemplateValue(variantObj, tag) {
		// Find the first templatenode with matching TemplateTag
		if (!variantObj || !variantObj.templatenodes) return undefined;
		const node = variantObj.templatenodes.find(tn => tn.TemplateTag === `\${${tag}}`);
		return node ? node.TemplateValue : undefined;
	}

	// Main function to assign SKU to each variant
	function assignSKUsToVariants(variants, skuStructure, delimiter = "-") {
		const tags = extractTagsFromStructure(skuStructure);

		for (const variant of variants) {
			const skuParts = [];

			//Add Product SkuPrefix
			const skuPrefix = localstate?.itemdata?.product?.SkuPrefix;
			if (skuPrefix) skuParts.push(skuPrefix);
			for (const tag of tags) {
				// For each ComponentType in the variant, try to find the TemplateValue
				let foundValue;
				for (const key in variant) {
					if (!variant[key] || !Array.isArray(variant[key].templatenodes || variant[key].templatenodes)) continue;
					foundValue = findTemplateValue(variant[key], tag);
					if (foundValue !== undefined) break;
				}
				if (foundValue !== undefined && foundValue !== null && foundValue !== "") {
					skuParts.push(foundValue);
				}
				// If not found, skip this tag (no empty string in list, so no double delimiter)
			}

			variant.SKU = skuParts.join(delimiter);
		}
		return variants;
	}


	const CalculateVariants = () => {
		//First we want to get distinct values by component type:
		//Product variants are stored like this:

		// Default to 0 in case there are no selected components
		localstate.variantcount = 0;

		//Check if variants exist:
		//OK is this next line OK? Will it fail before it even tries variants?
		if (!localstate.itemdata.product || !localstate.itemdata.product.productvariants) {
			//console.log("No product variants found.");
			return;
		}

		// Group the product variants by ComponentType
		const groupedByComponentType = localstate.itemdata.product.productvariants.reduce(
			(acc, variant) => {
				if (!acc[variant.ComponentType]) {
					acc[variant.ComponentType] = [];
				}
				acc[variant.ComponentType].push(variant);
				return acc;
			},
			{}
		);

		 //console.log(groupedByComponentType);
	   
		 // Calculate the total number of variants
		 const variantCounts = Object.values(groupedByComponentType).map((variants) =>
		   variants.filter((variant) => variant.Selected).length
		 );
	   
		 // Filter out ComponentTypes with no selected components and calculate the product
		 const totalVariants = variantCounts.reduce(
		   (acc, count) => (count > 0 ? acc * count : acc),
		   1
		 );
	   
		 // Update the ref and localstate
		 //variantcount.current = totalVariants;
		 localstate.variantcount = totalVariants;
	   
		// console.log('Total Variants:', totalVariants);







		 //SKU Creation Section (try with groupedByComponentType)

		// Example usage with your data (assuming 'data' contains your input JSON):
		const data = groupedByComponentType;
		var skuvariants = generateVariantCombinations(data);
		console.log(skuvariants);
		if (
			Array.isArray(skuvariants) &&
			skuvariants.length === 1 &&
			typeof skuvariants[0] === 'object' &&
			skuvariants[0] !== null &&
			Object.keys(skuvariants[0]).length === 0
		) {
			console.log("Array has one empty object");

		} else {
			const skuStructure = localstate.itemdata.SkuStructure;
		if (skuvariants && skuvariants.length>0){
			assignSKUsToVariants(skuvariants, skuStructure, "-");
		}

		


		// Create an array of promises
		const promises = skuvariants.map((variant, i) => {
			const postdata = { sku: variant.SKU };
			//Check current variantstore from localstate
			var skufound = false;
			for (var i=0; i<localstate.variantstore.length; i++){
				if (variant.SKU===localstate.variantstore[i].SKU){
					skufound = true;
					variant.Found = localstate.variantstore[i].Found;
					return;
				}
			}


			return axios.post(dbendpoint + "/skus/getskubysku", postdata, defaultpostoptions)
				.then(res => {
					if (res.status === 200) {
						if (res.data.Status === "login") {
							window.location.reload(false);
						}
						if (res.data.Status === "Success") {
							variant.Found = true;
							localstate.variantstore.push(variant);
						}
						if (res.data.Status === "Failure") {
							variant.Found = false;
							localstate.variantstore.push(variant);
						}
					} else {
						dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
						dispatch(setErrorTimeout(15));
					}
				})
				.catch(err => {
					// Handle network or server errors
					variant.Found = false;
					dispatch(newErrorMessage({ errmsg: "Network or server error.", errshow: true, errtimeout: 15, errtype: "warning" }));
					dispatch(setErrorTimeout(15));
				});
		});

		// Wait for all requests to finish
		Promise.all(promises).then(() => {
			// All .Found properties are now set, safe to render or update state here
			// For example:
			 //UpdateState(localstate);
			 //alert("this");
			// dispatch(setSkuVariants([...skuvariants]));
			localstate.skuvariants = skuvariants;
			UpdateState(localstate);
		});

		// //Now check the system for skus found:
		// var postdata = {};
		// for (var i=0; i<skuvariants.length;i++){
		// 	postdata = {
		// 		sku:skuvariants[i].SKU
		// 	}

		// 	axios.post(dbendpoint + "/skus/getskubysku", postdata, defaultpostoptions).then(res => {
		// 		//API should be setup to send 200 response with status. Merge paginated requests.
		// 		if (res.status === 200) {
		// 			//If ValidateUser() fails to verify user, it sends back 'login' error. 
		// 			if (res.data.Status === "login") {
		// 				//Not logged in. Reload page causes redirect to /login
		// 				window.location.reload(false);
		// 			}
		// 			//All new API calls should return a status.
		// 			if (res.data.Status === "Success") {
		// 				skuvariants[i].Found = true;
					
		// 				// UpdateState(localstate);
		// 				// dispatch(newErrorMessage({ errmsg: "Saved successfully.", errshow: true, errtimeout: 15, errtype: "ok" }));
		// 				// dispatch(setErrorTimeout(10));
		// 			}
		// 			if (res.data.Status === "Failure") {
		// 				skuvariants[i].Found = false;
		// 				// //Failure error
		// 				// dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 15, errtype: "warning" }));
		// 				// dispatch(setErrorTimeout(15));
		// 			}
		// 		} else {
		// 			//Non-200 message from server.
		// 			dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
		// 			dispatch(setErrorTimeout(15));
		// 		}
		// 	});
		// }
			





		// Example: print the first variant
		//console.log(JSON.stringify(skuvariants, null, 2));

		//console.log(extractTemplateNodes(skuvariants));



		//  //SKU CREATION SECTION

		//  //In order to shortcut some code, we need all the variants in their correct Sort Order:
		//  const variants = localstate.itemdata.product.productvariants.sort((a, b) => {
		// 	// Sort by priority.SortPriority
		// 	if (a.priority.SortPriority !== b.priority.SortPriority) {
		// 	  return a.priority.SortPriority - b.priority.SortPriority;
		// 	}
		// 	// If SortPriority is equal, sort by ComponentType
		// 	if (a.ComponentType < b.ComponentType) return -1;
		// 	if (a.ComponentType > b.ComponentType) return 1;
		// 	// Optionally, sort by ID for stability
		// 	return a.ID - b.ID;
		//   });



		//   //Fetch unique component type
		//   var componenttype = "";
		//   var previouscomponenttype = "";
		//   //Iterator for marshalling in template and column nodes
		//   var j=0;
		  
		//   var delimiter = localstate.itemdata.SkuDelimiter;
		//   var sku = "";
		//   var currentvariant = {};

		//  //Attempt to create skus!
		//  for (var i=0; i<variants.length;i++){
		// 	//Setup new variant!
		// 	currentvariant = {};

		// 	if (variants[i].Selected){
		// 		componenttype = variants[i].ComponentType;
		// 		if (componenttype !== previouscomponenttype){
		// 			//Start itteration for this new component type!
		// 			//First log the first one here and get j as new value of i
		// 			//Save this type as previous type!
		// 			previouscomponenttype = cloneDeep(componenttype);

		// 			//Add All Template & Column Nodes to Current Variant
		// 			for (j=0; j<variants[i].templatenodes.length; j++){
		// 				console.log("Template Node: "+variants[i].templatenodes[j].TemplateTag);
		// 			}
		// 		}
		// 		console.log("Total Skus:"+i);
		// 	}
		//  }
		}
		console.log(groupedByComponentType.length);
		//console.log("Sku Variants: "+skuvariants.length);
		//console.log(skuvariants);

		//const skuStructure = "${CPUSKU}-${RAMSKU}-${HDDSKU}-${RESSKU}-${FRSKU}-${WCSKU}-${COASKU}-${GRADESKU}";

		


	}


	useEffect(() => {
		if (!state.dbreload) {
			document.title = localstate.itemdata.Name;
		}
		if (state.dbreload) {
			localstate.dbreload = false;
			setTimeout(() => { LoadTemplate(); }, 300); // 100ms delay
		}
	}, [state]);


	useEffect(() => {
		if (currenteditor.Name && !currenteditor.Name.includes('Left') && !currenteditor.Name.includes('HTML')) {
			setTimeout(() => {
				//initSlateValue(currenteditor.Name);
			}, 500);
		}
	}, [currenteditor]);

	const skuCheckRunRef = useRef(0);
const skuFoundCacheRef = useRef(new Map()); // sku -> boolean

const selectionKey = useMemo(() => {
  const variants = state.itemdata?.product?.productvariants || [];
  return variants
    .map(v => `${v.ComponentID}:${v.Selected ? 1 : 0}`)
    .join("|");
}, [state.itemdata?.product?.productvariants]);

useEffect(() => {
  const productvariants = state.itemdata?.product?.productvariants || [];
  const skuStructure = state.itemdata?.SkuStructure || "";
  const skuDelimiter = state.itemdata?.SkuDelimiter || "-";
  const skuPrefix = state.itemdata?.product?.SkuPrefix || "";

  // Build grouped + count
  const grouped = productvariants.reduce((acc, v) => {
    (acc[v.ComponentType] ||= []).push(v);
    return acc;
  }, {});
  const types = Object.keys(grouped);
  const counts = types.map(t => grouped[t].filter(v => v.Selected).length);
  const hasEmptyType = counts.some(c => c === 0);
  const variantcount = types.length === 0 || hasEmptyType ? 0 : counts.reduce((a, b) => a * b, 1);

  if (variantcount === 0) {
    setState(prev => ({ ...prev, variantcount: 0, skuvariants: [], variantstore: [] }));
    return;
  }

  let skuvariants = generateVariantCombinations(grouped);
  skuvariants = assignSKUsToVariants(skuvariants, skuStructure, skuDelimiter, skuPrefix);

  // immediate UI update (without Found)
  setState(prev => ({ ...prev, variantcount, skuvariants }));

  // debounce + stale-run protection
  const runId = ++skuCheckRunRef.current;
  const timer = setTimeout(async () => {
    const checked = await Promise.all(
      skuvariants.map(async variant => {
        const sku = variant.SKU;

        if (skuFoundCacheRef.current.has(sku)) {
          return { ...variant, Found: skuFoundCacheRef.current.get(sku) };
        }

        try {
          const res = await axios.post(
            dbendpoint + "/skus/getskubysku",
            { sku },
            defaultpostoptions
          );
          const found = res?.data?.Status === "Success";
          skuFoundCacheRef.current.set(sku, found);
          return { ...variant, Found: found };
        } catch {
          skuFoundCacheRef.current.set(sku, false);
          return { ...variant, Found: false };
        }
      })
    );

    // ignore stale runs
    if (runId !== skuCheckRunRef.current) return;

    setState(prev => ({ ...prev, skuvariants: checked, variantstore: checked }));
  }, 300);

  return () => clearTimeout(timer);
}, [selectionKey, state.itemdata?.SkuStructure, state.itemdata?.SkuDelimiter, state.itemdata?.product?.SkuPrefix]);


	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	function removeTypeFromTextNodes(value) {
		function traverse(node) {
			if (Array.isArray(node)) {
				node.forEach(traverse);
			} else if (typeof node === 'object' && node !== null) {
				if ('text' in node) {
					delete node.type;
				}
				Object.values(node).forEach(traverse);
			}
		}

		traverse(value);
		return value;
	}

	const SaveChanges = () => {
		

		if (localstate.itemdata.Name.length === 0) {
			dispatch(newErrorMessage({ errmsg: "Item does not have a name!", errshow: true, errtimeout: 15, errtype: "warning" }));
			dispatch(setErrorTimeout(15));
			return;
		}

		//Hide current errors:
		dispatch(setErrorTimeout(0));
		
		let postdata = {
			item: cloneDeep(localstate.itemdata),
			createnewitem: createnewitem
		}

		if (deleteitem) {
			postdata.item.DeleteItem = true;
		}

		// if (!currenteditor.Name.includes("Left") && !currenteditor.Name.includes("HTML")) { //Ignore handling "Left"s which are always images in which the url does not need stringified.
		// 	var newvalue = removeTypeFromTextNodes(cloneDeep(postdata.item[currenteditor.Name]));
		// 	postdata.item[currenteditor.Name] = JSON.stringify(newvalue);
		// }



		//Can we mutate it here instead?

		//console.log(postdata.item[currenteditor.Name]);

		axios.post(dbendpoint + "/listingtemplate/update", postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					btnSave.current.style.display = "";
					btnPendingSave.current.style.display = "none";
					//Attempt to replace: btnSave.current.disabled = true;
					localstate.pendingsaves = false;
					//Use what little data we have to populate autocomplete:
					// localstate.itemdata = res.data.item;

					//We need this for subsequent reload of item.

					//If ID changed because of a clone event, reload!
					if (localstate.itemdata.ID !== res.data.item.ID){
						history.push("/listingtemplates/"+res.data.item.ID);
					} else {
						localstate.itemdata.ID = res.data.item.ID;
						localstate.dbreload = false;
						btnAddElement.current.disabled = false;
						//setCurrentEditor({Name:"", toolbar:false});
						//setSlateValue([]);
						setCurrentEditor({ Name: "" });
						UpdateState(localstate);
						dispatch(newErrorMessage({ errmsg: "Saved successfully.", errshow: true, errtimeout: 15, errtype: "ok" }));
						dispatch(setErrorTimeout(10));
					}
					
				}
				if (res.data.Status === "Deleted") {
					history.push("/");
					dispatch(setErrorTimeout(0));
				}
				if (res.data.Status === "Failure") {
					//Failure error
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 15, errtype: "warning" }));
					dispatch(setErrorTimeout(15));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(15));
			}
		});
	}


	//Some inputs will need to work via refs because we may be restricting some inputs and updating both the input itself and the JS variable
	const itemRefs = useRef({
		// CostEl: "",
		// PriceEl: "",
		// MarginEl: "",
		// PositiveIntegerEl: ""
	});

	//Changes to item
	const onChangeValue = (event, itemkey) => {
		var oldvalue = localstate.itemdata[itemkey];
		var newvalue = event.target.value;
		if (event.key !== "Tab" &&
			event.key !== "ArrowDown" &&
			event.key !== "ArrowUp" &&
			event.key !== "ShiftLeft" &&
			event.key !== "ShiftRight"
		) {

			if (itemkey === "SomeBoolean") {
				if (event.target.checked) {
					localstate.itemdata.SomeBoolean = 1;
				} else {
					localstate.itemdata.SomeBoolean = 0;
				}
			}

			//Float
			if (itemkey === "Cost" || itemkey === "Price" || itemkey === "Margin") {
				if (!oldvalue){
					oldvalue="0";
				}
				//A new value from RestrictInputNumber means it will override the input. We'll attempt to place the cursor back where it was. Otherwise, take in new value and do not adjust the input.
				newvalue = RestrictInputNumber(newvalue, oldvalue, event, "float"); //All arguments required. New universal function for all pages. However handle result below.
				if (newvalue) {
					itemRefs.current[itemkey+"El"].value = newvalue;
					localstate.itemdata[itemkey] = newvalue;
					//Attempt to refocus and place cursor at the end of the input - This will require we switch the input to text, then back to number:
					const inputElement = itemRefs.current[itemkey+"El"];
					inputElement.type = 'text';
					inputElement.focus();
					inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
					inputElement.type = 'number';
				} else {
					console.log("No newvalue returned, set value in localstate, but leave input untouched.");
					console.log(parseFloat(event.target.value).toFixed(2));
					localstate.itemdata[itemkey] = parseFloat(event.target.value).toFixed(2);
				}
			}

			//Positive Integer:
			if (itemkey === "PositiveInteger") {
				if (!oldvalue){
					oldvalue="0";
				}
				//A new value from RestrictInputNumber means it will override the input. We'll attempt to place the cursor back where it was. Otherwise, take in new value and do not adjust the input.
				newvalue = RestrictInputNumber(newvalue, oldvalue, event, "positiveinteger"); //All arguments required. New universal function for all pages. However handle result below.
				if (newvalue) {
					itemRefs.current[itemkey+"El"].value = newvalue;
					localstate.itemdata[itemkey] = newvalue;
					//Attempt to refocus and place cursor at the end of the input - This will require we switch the input to text, then back to number:
					const inputElement = itemRefs.current[itemkey+"El"];
					inputElement.type = 'text';
					inputElement.focus();
					inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
					inputElement.type = 'number';
				} else {
					console.log("No newvalue returned, set value in localstate, but leave input untouched.");
					console.log(parseInt(event.target.value));
					localstate.itemdata[itemkey] = parseInt(event.target.value);
				}
			}

			if (itemkey.includes('Left')){
				localstate.itemdata[itemkey] = newvalue;
				localstate.pendingsaves = true;
				//Old
				// btnSave.current.style.color = "white";
				// btnSave.current.style.backgroundColor = "#01579B";
				btnSave.current.style.display="none";
				btnPendingSave.current.style.display="";
				//DON'T UPDATE STATE
			}
			if (itemkey === "SkuStructure" || itemkey === "SkuDelimiter" || itemkey==="TitleStructure" || itemkey==="Name") {
				localstate.itemdata[itemkey] = newvalue;
				localstate.pendingsaves = true;
				//Old
				// btnSave.current.style.color = "white";
				// btnSave.current.style.backgroundColor = "#01579B";
				btnSave.current.style.display="none";
				btnPendingSave.current.style.display="";
				UpdateState(localstate);
			}
			
			
		}

	}



	const onDBAutoCompleteChange = (newvalue, searchkey) => {
		if (searchkey === "listingtemplates") {
			// console.log("Detect if new...");
			//console.log(newvalue);
			if (newvalue) {
				if (newvalue.hasOwnProperty('addnewitem')) {
					if (newvalue.addnewitem === true) {
						localstate.itemdata.PendingItem = 1; //Setup for first creation of item
						localstate.itemdata.Name = cloneDeep(newvalue.newitemvalue);
						//Allow save of new item:
						btnSave.current.style.display = "none";
						btnPendingSave.current.style.display = "";
						UpdateState(localstate);
					}
				} else {
					// localstate.dbreload = true;
					// localstate.itemdata.ID = newvalue.ID;
					// UpdateState(localstate);
					history.push('/listingbuilder/'+newvalue.ID);
				}
			}
		}

		if (searchkey === "products") {
			btnSave.current.style.display = "none";
			btnPendingSave.current.style.display = "";
			localstate.itemdata.ProductID = newvalue.ProductID;

			//alert(newvalue.Name);
		}
	}

	//UseState variable controls warning message as well as checked status of Checkbox
	const [deleteitem, setDeleteItem] = useState(false);
	const markForDelete = () =>{
		if (!deleteitem) {
			dispatch(newErrorMessage({ errmsg: "Item has been marked for deletion. Click 'Save Changes' to complete deletion.", errshow: true, errtimeout: 30000, errtype: "warning" }));
			dispatch(setErrorTimeout(30000));
			ToggleSaveBtnStatus(true);
		} else {
			dispatch(newErrorMessage({ errmsg: "Deletion cancelled.", errshow: true, errtimeout: 10, errtype: "ok" }));
			dispatch(setErrorTimeout(10));
			ToggleSaveBtnStatus(false); //Remove access to regular save button if neccessary.
		}
		setDeleteItem(!deleteitem);
	}

	const [createnewitem, setCreateNewItem] = useState(false);
	const toggleCreateNewItem = () =>{
		if (!createnewitem) {
			dispatch(newErrorMessage({ errmsg: "Saving will create a copy of this template into a new record.", errshow: true, errtimeout: 30000, errtype: "warning" }));
			dispatch(setErrorTimeout(30000));
			ToggleSaveBtnStatus(true);
		} else {
			dispatch(newErrorMessage({ errmsg: "New template canceled.", errshow: true, errtimeout: 10, errtype: "ok" }));
			dispatch(setErrorTimeout(1000));
			ToggleSaveBtnStatus(false); //Remove access to regular save button if neccessary.
		}
		localstate.itemdata.PendingItem = !createnewitem;
		UpdateState(localstate);
		setCreateNewItem(!createnewitem);
	}

	const ToggleSaveBtnStatus = (haspendingsave) =>{
		//TRUE: We have pending saves.
		if (haspendingsave){
			btnSave.current.style.display = "none";
			btnPendingSave.current.style.display = "";
		} else {
		//FALSE: We no longer have pending saves.
		btnSave.current.style.display = "";
		btnPendingSave.current.style.display = "none";
		}
	}



	/* View Options Menu */
	const [showAddElementMenu, setViewOptionsMenu] = useState(null);
	const ShowAddElementMenu = (event) => {
		setViewOptionsMenu(event.currentTarget);
	}
	const CloseAddElementMenu = () => {
		setViewOptionsMenu(null);
	}

	const AddElement = (elementname) => {
		CloseAddElementMenu();
		//Add provision for adding placeholder for "Left"s
		if (elementname.includes("Left") || elementname.includes("HTML")) {
			localstate.itemdata[elementname] = "placeholder"; //There is an issue with sending a blank string back to the DB. It thinks it's the same as null and sets it to null. On reload, our element won't appear at all. I should have added just a few more render settings for these.
		}
		//Need to activate the right side too. Fill data for it:
		if (elementname.includes("Left")) {
			const rightside = elementname.replace("Left", "Right");
			localstate.itemdata[rightside] = "placeholder text"

			//Reset width!
			const lastchar = elementname[elementname.length -1];
			localstate.itemdata[elementname.slice(0, -1) + "Width" + lastchar] = 50;


			//localstate.itemdata[rightside + "HTML"] = serializeAll(localstate.itemdata[rightside]);
		}
		setCurrentEditor({
			Name: elementname
		});
	}



	//TIPTAP
	const CustomBulletList = BulletList.extend({
		addAttributes() {
			return {
				...this.parent?.(),
				lineHeight: {
					default: null,
					parseHTML: element => element.style.lineHeight || null,
					renderHTML: attributes => {
						return attributes.lineHeight ? { style: `line-height: ${attributes.lineHeight};` } : {}
					},
				},
				style: {
					default: 'line-height:1;',
				}
			}
		},
	});


	const CustomTable = Table.extend({
		addAttributes() {
			return {
				...this.parent?.(),
				class: {
					default: null,
					parseHTML: element => element.getAttribute('class'),
					renderHTML: attributes => {
						return { class: attributes.class }
					},
				},
				style: {
					default: 'border-collapse: collapse; margin: 0 auto; min-width:70%;',
					parseHTML: element => element.getAttribute('style'),
					renderHTML: attributes => {
						return { style: attributes.style }
					},
				},
			}
		},
	});

	const CustomTableHeader = TableHeader.extend({
		addAttributes() {
		  return {
			...this.parent?.(),
			style: {
				default: 'background-color: #EEE; border: 1px solid #BBB;padding:2px 4px;',
			  parseHTML: element => element.getAttribute('style'),
			  renderHTML: attributes => {
				return attributes.style ? { style: attributes.style } : {}
			  },
			},
		  }
		},
	  });


	  const CustomTableCell = TableCell.extend({
		addAttributes() {
		  return {
			...this.parent?.(),
			style: {
				default: 'border: 1px solid #eee;padding:2px; 4px',
			  parseHTML: element => element.getAttribute('style'),
			  renderHTML: attributes => {
				return attributes.style ? { style: attributes.style } : {}
			  },
			},
		  }
		},
	  });


	const TipTapEditor = (content) => {
		//console.log(content);
		// Ensure content is not null or undefined
		const editorContent = content?.content || '<p>New</p>';
		//console.log(editorContent);
		return (
			<EditorProvider 
				slotBefore={<MenuBar />} 
				extensions={extensions} 
				content={editorContent}
				onUpdate={({editor}) => {
					// This is called whenever the content changes
					//console.log('Editor content updated:', editor.getHTML());
					btnSave.current.style.display = "none";
					btnPendingSave.current.style.display = "";

					localstate.itemdata[currenteditor.Name] =  editor.getHTML();
				}}
				
				></EditorProvider>
		);
	}


	


	const [opencolorselection, setOpenColorSelection] = useState(false); 
	const [textcolor, setTextColor] = React.useState('#000')


	const MenuBar = () => {
		const { editor } = useCurrentEditor()
	  
		if (!editor) {
		  return null
		}

		const ColorOption = (coloroption) => {
			// console.log("#######################################");
			// console.log(coloroption.color);
			return (
				<Box onClick={()=>{
						editor.chain().focus().setColor(coloroption.color).run();
					}}
					className={classes.hoverunit}
					height={10}
					width={10}
					sx={{backgroundColor:coloroption.color,
						display:"inline-block",
						marginBottom:"0px",
						marginRight:"2px",
						padding:"0px"
					}}
				>
				</Box>
			)
		}
		
	  
		return (

			<ThemeProvider theme={editorTheme}>
	 			<AppBar
	 				sx={{ boxShadow: 0, border: "1px solid #CCC" }}
	 				position="static" enableColorOnDark>
	 				<MuiToolbar variant="dense" sx={{ flexWrap: 'wrap', justifyContent: "center" }}>
	 					{/* Font Select */}
						 <Select
							defaultValue={"Roboto"}
							displayEmpty
							sx={{
								color: '#333',
								'.MuiOutlinedInput-notchedOutline': { border: "0px", borderColor: '#333' },
								'&:hover .MuiOutlinedInput-notchedOutline': { border: "0px", borderColor: '#333' },
								'.MuiSvgIcon-root': { color: '#333' },
								minWidth: 100,
								'& .MuiSelect-select': {
									padding: '4px 24px 4px 8px', // Reduced padding: top, right, bottom, left
								},
							}}
						>
							<MenuItem value="" disabled>
								Font Family
							</MenuItem>
							<MenuItem 
								onClick={() => editor.chain().focus().setFontFamily("Arial").run()} 
								value="Arial">
								Arial
							</MenuItem>
							<MenuItem 
								onClick={() => editor.chain().focus().setFontFamily("Times New Roman").run()} 
								value="Times New Roman">
								Times New Roman
							</MenuItem>
							<MenuItem 
								onClick={() => editor.chain().focus().setFontFamily("Roboto").run()} 
								value="Roboto">
								Roboto
							</MenuItem>
							<MenuItem 
								onClick={() => editor.chain().focus().setFontFamily("Inter").run()} 
								value="Inter">
								Inter
							</MenuItem>
						</Select>


						{/* Block Type */}
						<Select
							defaultValue={"default"}
							displayEmpty
							sx={{
								color: '#333',
								marginLeft: "5px",
								'.MuiOutlinedInput-notchedOutline': { border: "0px", borderColor: '#333' },
								'&:hover .MuiOutlinedInput-notchedOutline': { border: "0px", borderColor: '#333' },
								'.MuiSvgIcon-root': { color: '#333' },
								minWidth: 100,
								'& .MuiSelect-select': {
									padding: '4px 24px 4px 8px', // Reduced padding: top, right, bottom, left
								},
							}}
						>
							<MenuItem value="default" disabled>
								Block Type
							</MenuItem>
							<MenuItem onClick={() => editor.chain().focus().setParagraph().run()} value="paragraph">Paragraph</MenuItem>
							<MenuItem onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()} value="heading-one">H1</MenuItem>
							<MenuItem onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} value="heading-two">H2</MenuItem>
							<MenuItem onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()} value="heading-three">H3</MenuItem>
							<MenuItem onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()} value="heading-four">H4</MenuItem>
							<MenuItem onClick={() => editor.chain().focus().toggleHeading({ level: 5 }).run()} value="heading-five">H5</MenuItem>
						</Select>


						{/* Font Size */}
						<Select
							defaultValue={"default"}
							displayEmpty
							sx={{
								color: '#333',
								marginLeft: "5px",
								'.MuiOutlinedInput-notchedOutline': { border: "0px", borderColor: '#333' },
								'&:hover .MuiOutlinedInput-notchedOutline': { border: "0px", borderColor: '#333' },
								'.MuiSvgIcon-root': { color: '#333' },
								minWidth: 80,
								'& .MuiSelect-select': {
									padding: '4px 24px 4px 8px', // Reduced padding: top, right, bottom, left
								},
							}}
						>
							<MenuItem value="default" disabled>
								Size
							</MenuItem>
							
							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("12px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="12">
									12px
							</MenuItem>

							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("14px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="14">
									14px
							</MenuItem>

							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("16px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="16">
									16px
							</MenuItem>

							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("18px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="18">
									18px
							</MenuItem>

							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("20px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="20">
									20px
							</MenuItem>

							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("22px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="22">
									22px
							</MenuItem>

							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("26px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="26">
									26px
							</MenuItem>

							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("30px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="30">
									30px
							</MenuItem>

							<MenuItem onClick={() => {
								editor.chain().focus().setFontSize("36px").run();
								editor.view.updateState(editor.view.state);
								}}
								value="36">
									36px
							</MenuItem>

						</Select>

						 					{(opencolorselection) &&
							<div style={{ position: "relative", top: "0px", display: "inline-block" }}>
								<div style={{ position: "absolute", top: "20px", right: "-110px", zIndex: 9999 }}>
									<Sketch
										style={{ marginLeft: 20 }}
										color={textcolor}
										onChange={(color) => {
											//setColor(color.hex);
											//setOpenColorSelection(false);
											editor.chain().focus().setColor(color.hex).run();
											editor.view.updateState(editor.view.state);
										}}
									/>
								</div>
							</div>
						}

						<div style={{width:"80px", paddingRight:"10px"}}>
							<ColorOption color="#000000" />
						<ColorOption color="#404040" />
						<ColorOption color="#808080" />
						<ColorOption color="#DDDDDD" />
						<ColorOption color="#01579B" />
						<ColorOption color="#8eb7e7" />
						<ColorOption color="#FF9999 " />
						<ColorOption color="red" />
						<ColorOption color="green" />
						<ColorOption color="orange" />
						</div>
						
						



						{/* <IconButton onClick={() => setOpenColorSelection(!opencolorselection)}
							edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
							<PaletteIcon />
						</IconButton> */}

						<IconButton onClick={() => editor.chain().focus().toggleBold().run()}
							edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
							<FormatBoldIcon />
						</IconButton>

						<IconButton onClick={() => editor.chain().focus().toggleItalic().run()}
							edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
							<FormatItalicIcon />
						</IconButton>

						<IconButton onClick={() => editor.chain().focus().toggleUnderline().run()}
							edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
							<FormatUnderlinedIcon />
						</IconButton>

						<IconButton onClick={() => editor.chain().focus().setTextAlign('left').run()}
							edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
							<FormatAlignLeftIcon />
						</IconButton>

						<IconButton onClick={() => editor.chain().focus().setTextAlign('center').run()}
							edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
							<FormatAlignCenterIcon />
						</IconButton>

						<IconButton onClick={() => editor.chain().focus().setTextAlign('right').run()}
							edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
							<FormatAlignRightIcon />
						</IconButton>

						<IconButton onClick={() => editor.chain().focus().toggleBulletList().run()} 
							color="inherit">
							<FormatListBulletedIcon />
						</IconButton>

						<IconButton onClick={() => editor.chain().focus().toggleOrderedList().run()}
							color="inherit">
							<FormatListNumberedIcon />
						</IconButton>

						{(!editor.can().deleteTable()) &&
							<IconButton onClick={() => editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()}
								color="inherit">
								<GridOnIcon />
							</IconButton>
						}

						{(editor.can().deleteTable()) &&
							<IconButton onClick={() => editor.chain().focus().deleteTable().run()}
								color="inherit">
								<GridOffIcon />
							</IconButton>
						}

						{(editor.can().deleteRow()) &&
							<ButtonGroup variant="contained" aria-label="Basic button group" sx={{marginLeft:"5px"}}>
								<IconButton onClick={() => editor.chain().focus().addRowAfter().run()} disabled={!editor.can().addRowAfter()}
									color="inherit">
									<AddIcon />
								</IconButton>
								<Typography
									variant="button"
									sx={{ display: "flex", alignItems: "center", px: 2 }}
								>
									Row
								</Typography>
								<IconButton onClick={() => editor.chain().focus().deleteRow().run()} disabled={!editor.can().deleteRow()}
									color="inherit">
									<RemoveIcon />
								</IconButton>
							</ButtonGroup>
						}

						{(editor.can().deleteColumn()) &&
							<ButtonGroup variant="contained" aria-label="Basic button group" sx={{marginLeft:"5px"}}>
								<IconButton onClick={() => editor.chain().focus().addColumnAfter().run()} disabled={!editor.can().addColumnAfter()}
									color="inherit">
									<AddIcon />
								</IconButton>
								<Typography
									variant="button"
									sx={{ display: "flex", alignItems: "center", px: 2 }}
								>
									Column
								</Typography>
								<IconButton onClick={() => editor.chain().focus().deleteColumn().run()} disabled={!editor.can().deleteColumn()}
									color="inherit">
									<RemoveIcon />
								</IconButton>
							</ButtonGroup>
						}

						{(editor.can().deleteColumn()) &&
							<IconButton onClick={() =>
								editor.commands.updateAttributes('table', { class: 'my-custom-table', style: 'border: 2px solid red;' })
								//</MuiToolbar>editor.chain().focus().deleteTable().run()
							}
								color="inherit">
								.icon. Table border Red 2px
							</IconButton>
						}


						{(editor.can().deleteColumn()) &&
							<IconButton onClick={() =>
								editor.commands.updateAttributes('tableHeader', { style: 'background-color:#EEE;', })
								//</MuiToolbar>editor.chain().focus().deleteTable().run()
							}
								color="inherit">
								.icon. Table Header Background
							</IconButton>
						}
						







						<IconButton onClick={() => deleteElement(currenteditor.Name)} color="inherit">
							<DeleteIcon />
						</IconButton>


					</MuiToolbar>
				</AppBar>
			</ThemeProvider>









		//  
		)
	  }
	

	const extensions = [
		Color.configure({ types: [TextStyle.name, ListItem.name] }),
		TextStyle,
		FontSize,
		FontFamily,
		Underline,
		CustomBulletList,
		StarterKit.configure({
			bulletList: {
				keepMarks: true,
				keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
			},
			orderedList: {
				keepMarks: true,
				keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
			},
		}),
		TextAlign.configure({
			types: ['heading', 'paragraph'],
		}),
		//BulletList,
		ListKeymap,
		// Table.configure({
		// 	resizable: true,
		//   }),
		CustomTable.configure({
			resizable: true,
		  }),
		  CustomTableCell,
		  TableRow,
		  CustomTableHeader,
	];
















	//OLD SLATE JUNK


	const [slatevalue, setSlateValue] = useState([]);

	// const initSlateValue = (elementname) => {
	// 	if (localstate.itemdata[elementname]) {
	// 		console.log(typeof localstate.itemdata[elementname]);
	// 		//For initial values, we'll already have a good-to-go slate value.

	// 		if (typeof localstate.itemdata[elementname] === "string") {
	// 			const newslatevalue = normalizeSlateData(sanitizeValue(JSON.parse(localstate.itemdata[elementname])));
	// 			setSlateValue(newslatevalue);
	// 		} else {
	// 			const newslatevalue = normalizeSlateData(sanitizeValue(localstate.itemdata[elementname]));
	// 			setSlateValue(newslatevalue);
	// 		}
	// 	} else {
	// 		setSlateValue(initialValue);
	// 	}
	// }


	// //We haven't solved issues with Slate normalization just yet, so simply allow the user to sweep the value.
	const SweepValue = (elementname) =>{
		localstate.itemdata[elementname] = "";
	}



	const deleteElement = (templatename) => {
		btnSave.current.style.display = "none";
		btnPendingSave.current.style.display = "";
		//console.log(localstate.itemdata[templateelement.Name]);
		//alert("Delete Element");
		localstate.itemdata[templatename] = null;

		
		

		if (templatename.includes("Left")){
			//FeatureLeft1
			const templateroot = templatename.slice(0, -5);
			const templateindex = templatename.slice(-1);
			localstate.itemdata[templateroot+"Right"+templateindex] = null;
		}

		if (templatename.includes("Right")){
			//FeatureLeft1
			const templateroot = templatename.slice(0, -6);
			const templateindex = templatename.slice(-1);
			localstate.itemdata[templateroot+"Left"+templateindex] = null;
		}
		

		setCurrentEditor({ Name: "" });
		UpdateState(localstate);
	}




	const renderLeaf = ({ attributes, children, leaf }) => {
		let styledChildren = children;
	
		if (leaf.bold) {
			styledChildren = <strong>{styledChildren}</strong>;
		}
		if (leaf.italic) {
			styledChildren = <em>{styledChildren}</em>;
		}
		if (leaf.fontSize) {
			styledChildren = (
				<span
					style={{
						fontSize: `${leaf.fontSize}px`,
						lineHeight: leaf.lineHeight || "normal",
					}}
				>
					{styledChildren}
				</span>
			);
		}
		if (leaf.color) {
			styledChildren = <span style={{ color: leaf.color }}>{styledChildren}</span>;
		}
		if (leaf.font) {
			styledChildren = <span style={{ fontFamily: leaf.font }}>{styledChildren}</span>;
		}
		if (leaf.underline) {
			styledChildren = <span style={{ textDecoration: "underline" }}>{styledChildren}</span>;
		}
	
		return <span {...attributes}>{styledChildren}</span>;
	};



	// const isImageUrl = url => {
	// 	//This isUrl library sucks, don't use it.
	// 	// if (!url) return false
	// 	// if (!isUrl(url)) return false
	// 	const ext = new URL(url).pathname.split('.').pop()
	// 	return imageExtensions.includes(ext)
	// }


	const templateelements = [
		{
			Name: "HeadHTML", //Coincides with DB column
			Title: "Head HTML", //Friendly render of option
			TemplateType: "html",
			Introduction: "Optional setup html imports of css, fonts, and the creation of the document as a structured HTML page complete with the remaining elements nested with the alias ${content}.",
			menuoption: true,
		},
		{
			Name: "Header",
			Title: "Header",
			TemplateType: "editor",
			Introduction: "Potential introduction of company, feature our value-added services, or quick links.",
			menuoption: true,
		},
		{
			Name: "TitleAndText",
			Title: "Title And Text",
			TemplateType: "editor",
			Introduction: "Introduce the product with a large title and a paragraph of basic hooks based on product strengths.",
			menuoption: true,
		},
		{
			Name: "FeatureLeft1",
			Title: "Feature Pair 1",
			TemplateType: "image",
			Introduction: "Feature 1 Left Side",
			menuoption: true,
		},
		{
			Name: "FeatureRight1",
			Title: "Feature Right 1",
			TemplateType: "editor",
			Introduction: "Feature 1 Right Side",
			menuoption: false, //Automatically added by Feature 1
		},
		{
			Name: "FeatureLeft2",
			Title: "Feature Pair 2",
			TemplateType: "image",
			Introduction: "Feature 2 Left Side",
			menuoption: true,
		},
		{
			Name: "FeatureRight2",
			Title: "Feature Right 2",
			TemplateType: "editor",
			Introduction: "Feature 2 Right Side",
			menuoption: false, //Automatically added by Feature 2
		},
		{
			Name: "FeatureLeft3",
			Title: "Feature Pair 3",
			TemplateType: "image",
			Introduction: "Feature 3 Left Side",
			menuoption: true,
		},
		{
			Name: "FeatureRight3",
			Title: "Feature Right 3",
			TemplateType: "editor",
			Introduction: "Feature 3 Right Side",
			menuoption: false, //Automatically added by Feature 3
		},
		{
			Name: "FeatureLeft4",
			Title: "Feature Pair 4",
			TemplateType: "image",
			Introduction: "Feature 4 Left Side",
			menuoption: true,
		},
		{
			Name: "FeatureRight4",
			Title: "Feature Right 4",
			TemplateType: "editor",
			Introduction: "Feature 4 Right Side",
			menuoption: false, //Automatically added by Feature 4
		},
		{
			Name: "FeatureLeft5",
			Title: "Feature Pair 5",
			TemplateType: "image",
			Introduction: "Feature 5 Left Side",
			menuoption: true,
		},
		{
			Name: "FeatureRight5",
			Title: "Feature Right 5",
			TemplateType: "editor",
			Introduction: "Feature 5 Right Side",
			menuoption: false, //Automatically added by Feature 5
		},
		{
			Name: "FeatureLeft6",
			Title: "Feature Pair 6",
			TemplateType: "image",
			Introduction: "Feature 6 Left Side",
			menuoption: true,
		},
		{
			Name: "FeatureRight6",
			Title: "Feature Right 6",
			TemplateType: "editor",
			Introduction: "Feature 6 Right Side",
			menuoption: false, //Automatically added by Feature 6
		},
		{
			Name: "FeatureLeft7",
			Title: "Feature Pair 7",
			TemplateType: "image",
			Introduction: "Feature 7 Left Side",
			menuoption: true,
		},
		{
			Name: "FeatureRight7",
			Title: "Feature Right 7",
			TemplateType: "editor",
			Introduction: "Feature 7 Right Side",
			menuoption: false, //Automatically added by Feature 7
		},
		{
			Name: "FeatureLeft8",
			Title: "Feature Pair 8",
			TemplateType: "image",
			Introduction: "Feature 8 Left Side",
			menuoption: true,
		},
		{
			Name: "FeatureRight8",
			Title: "Feature Right 8",
			TemplateType: "editor",
			Introduction: "Feature 8 Right Side",
			menuoption: false, //Automatically added by Feature 8
		},
		{
			Name: "PurchaseIncludes",
			Title: "Purchase Includes",
			TemplateType: "editor",
			Introduction: "Describe item, accessories, chargers, and quantity details. Be specific to this one purchase.",
			menuoption: true,
		},
		{
			Name: "WarrantyPolicies",
			Title: "Warranty Policies",
			TemplateType: "editor",
			Introduction: "Describe associated warranty, satisfaction guarantee, and return policy.",
			menuoption: true,
		},

	];

	const EditorContainer = (templateelement) => {

	}

	const GetElementWidth = (templateelement, templateindex) => {
		var width = 100;
		var margintop = 0;
		var display = "inline-block";
		if (templateelement.Name.includes("Left")) {
			var featureindex = templateelement.Name.slice(-1);
			//console.log("Index: " + featureindex);
			//console.log("About to get: " + "FeatureLeftWidth" + featureindex);
			width = localstate.itemdata["FeatureLeftWidth" + featureindex];
			//Margin is trickier. We need to look at the next index item and test if it is the current editor. That way we can add the margin to this side as well!
			//console.log(templateelements);
			//console.log(featureindex);
			if (currenteditor.Name === templateelements[templateindex+1].Name){
				margintop=50; 
			}
		}
		if (templateelement.Name.includes("Right")) {
			var featureindex = templateelement.Name.slice(-1);
			//console.log("Index: " + featureindex);
			//console.log("About to get: " + "FeatureLeftWidth" + featureindex);
			width = 100 - parseInt(localstate.itemdata["FeatureLeftWidth" + featureindex]);
		}

		//Now also setup 0 width elements as no render at all!
		if (width===0){
			display = "none";
		}

		
		//console.log(width);

		if(currenteditor.Name === templateelement.Name){
			margintop=50; 
		}

		return {
			width: width + "%", minHeight: "20px", display: display, verticalAlign: "top", marginTop:margintop+"px"
		}
	}

	const ChangeHTML = (event) => {
		localstate.itemdata.HeadHTML = event.target.value;
		btnSave.current.style.display = "none";
		btnPendingSave.current.style.display = "";
	}


	const GenerateDescription = (variantindex) => {
		//Gen Method is copy or download.
		console.log(localstate.skuvariants);

		//console.log(localstate.itemdata);

		//Generate and save into localstate.listings
		//Start with localstate.itemdata

		//Create Description
		var descriptiontemplate = "";

		
		//Gather up all the HTML from regular containers (everything but Head\HTML):
		//Gallery Images aren't used for descriptions. 
		if (localstate.itemdata.Header){
			descriptiontemplate += localstate.itemdata.Header;
		}

		if (localstate.itemdata.TitleAndText){
			descriptiontemplate += localstate.itemdata.TitleAndText;
		}

		if (localstate.itemdata.FeatureLeft1){
			//Check for 0 left or 0 right
			if (localstate.itemdata.FeatureLeftWidth1!==0 && localstate.itemdata.FeatureLeftWidth1!==100){
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+localstate.itemdata.FeatureLeftWidth1+"%;\"><img style=\"width:100%; height:auto; display:block;padding-bottom:10px;\" src=\""+localstate.itemdata.FeatureLeft1+"\" \/></div>";
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight1+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth1===0){
				//No Picture, just text:
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight1+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth1===100){
				//Picture Only
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:100%;padding-bottom:10px;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft1+"\" \/></div>";
			}
		}

		if (localstate.itemdata.FeatureLeft2){
			//Check for 0 left or 0 right
			if (localstate.itemdata.FeatureLeftWidth2!==0 && localstate.itemdata.FeatureLeftWidth2!==100){
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+localstate.itemdata.FeatureLeftWidth2+"%;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft2+"\" \/></div>";
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight2+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth2===0){
				//No Picture, just text:
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth2)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight2+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth2===100){
				//Picture Only
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:100%;padding-bottom:10px;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft2+"\" \/></div>";
			}
		}

		if (localstate.itemdata.FeatureLeft3){
			//Check for 0 left or 0 right
			if (localstate.itemdata.FeatureLeftWidth3!==0 && localstate.itemdata.FeatureLeftWidth3!==100){
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+localstate.itemdata.FeatureLeftWidth3+"%;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft3+"\" \/></div>";
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight3+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth3===0){
				//No Picture, just text:
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth3)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight3+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth3===100){
				//Picture Only
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:100%;padding-bottom:10px;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft3+"\" \/></div>";
			}
		}

		if (localstate.itemdata.FeatureLeft4){
			//Check for 0 left or 0 right
			if (localstate.itemdata.FeatureLeftWidth4!==0 && localstate.itemdata.FeatureLeftWidth4!==100){
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+localstate.itemdata.FeatureLeftWidth4+"%;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft4+"\" \/></div>";
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight4+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth4===0){
				//No Picture, just text:
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth4)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight4+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth4===100){
				//Picture Only
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:100%;padding-bottom:10px;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft4+"\" \/></div>";
			}
		}

		
		if (localstate.itemdata.FeatureLeft5){
			//Check for 0 left or 0 right
			if (localstate.itemdata.FeatureLeftWidth5!==0 && localstate.itemdata.FeatureLeftWidth5!==100){
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+localstate.itemdata.FeatureLeftWidth5+"%;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft5+"\" \/></div>";
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight5+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth5===0){
				//No Picture, just text:
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth5)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight5+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth5===100){
				//Picture Only
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:100%;padding-bottom:10px;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft5+"\" \/></div>";
			}
		}

		if (localstate.itemdata.FeatureLeft6){
			//Check for 0 left or 0 right
			if (localstate.itemdata.FeatureLeftWidth6!==0 && localstate.itemdata.FeatureLeftWidth6!==100){
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+localstate.itemdata.FeatureLeftWidth6+"%;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft6+"\" \/></div>";
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight6+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth6===0){
				//No Picture, just text:
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth6)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight6+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth6===100){
				//Picture Only
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:100%;padding-bottom:10px;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft6+"\" \/></div>";
			}
		}

		
		if (localstate.itemdata.FeatureLeft7){
			//Check for 0 left or 0 right
			if (localstate.itemdata.FeatureLeftWidth7!==0 && localstate.itemdata.FeatureLeftWidth7!==100){
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+localstate.itemdata.FeatureLeftWidth7+"%;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft7+"\" \/></div>";
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight7+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth7===0){
				//No Picture, just text:
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth7)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight7+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth7===100){
				//Picture Only
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:100%;padding-bottom:10px;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft7+"\" \/></div>";
			}
		}

		if (localstate.itemdata.FeatureLeft8){
			//Check for 0 left or 0 right
			if (localstate.itemdata.FeatureLeftWidth8!==0 && localstate.itemdata.FeatureLeftWidth8!==100){
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+localstate.itemdata.FeatureLeftWidth8+"%;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft8+"\" \/></div>";
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth1)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight8+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth8===0){
				//No Picture, just text:
				descriptiontemplate+="<div class=\"featureright\" style=\"display:inline-block; vertical-align:top; margin:auto; width:"+(100-localstate.itemdata.FeatureLeftWidth8)+"%;\"><div style=\"padding:5px 15px; \">"+localstate.itemdata.FeatureRight8+"</div></div></div>";
			} else if (localstate.itemdata.FeatureLeftWidth8===100){
				//Picture Only
				descriptiontemplate+="<div><div class=\"featureleft\" style=\"display:inline-block; vertical-align:top; margin:auto; width:100%;padding-bottom:10px;\"><img style=\"width:100%; height:auto; display:block;\" src=\""+localstate.itemdata.FeatureLeft8+"\" \/></div>";
			}
		}

		

		

		


		if (localstate.itemdata.PurchaseIncludes){
			descriptiontemplate+=localstate.itemdata.PurchaseIncludes;
		}

		if (localstate.itemdata.WarrantyPolicies){
			descriptiontemplate+=localstate.itemdata.WarrantyPolicies;
		}


		//First check if we need to put content into HEAD/HTML:
		if (localstate.itemdata.HeadHTML){ //Checks for null or blank
			if (localstate.itemdata.HeadHTML.includes("${CONTENT}")){
				descriptiontemplate = localstate.itemdata.HeadHTML.replace('${CONTENT}', descriptiontemplate);
				//descriptiontemplate = localstate.itemdata.HeadHTML;
			}
		}




		//Find all template tags:
		// Use regex to match all occurrences of ${SOMETHING}
		var currentdescription = cloneDeep(descriptiontemplate);
		const templateTags = Array.from(currentdescription.matchAll(/\$\{([A-Z0-9_]+)\}/g)).map(match => match[0]);
		console.log(templateTags);
		//Produces templateTags = ['${CPUDETAIL}'.....]



		//Converting this to generate just description by index and returning it.
		currentdescription = cloneDeep(descriptiontemplate);
		for (var j=0; j<templateTags.length; j++){
			//For each template tag.... drill through skuvariant templatenodes!
			for (var key in localstate.skuvariants[variantindex]) {
				var skucomponent = localstate.skuvariants[variantindex][key]; // The actual object (COA, Webcam, etc.)
				// console.log(key); // e.g., "COA"
				// console.log(skucomponent); // The full object
			  
				// Loop through templatenodes array if it exists
				if (skucomponent.templatenodes) {
				  for (var l = 0; l < skucomponent.templatenodes.length; l++) {
					var templatenode = skucomponent.templatenodes[l];
					//console.log(templatenode.TemplateTag);
					if (templatenode.TemplateTag === templateTags[j]){
						currentdescription = currentdescription.replace(templateTags[j], templatenode.TemplateValue);
						// console.log("#################################");
						// console.log(templatenode.TemplateValue);
					}
				  }
				}
			  }
		}

		return currentdescription;






		// //Sku Variants Loop: Replace text patterns with template nodes!
		// for (var i=0; i<localstate.skuvariants.length; i++){
		// 	//Refresh template with fresh copy
		// 	currenttemplate = cloneDeep(descriptiontemplate);

		// 	console.log(localstate.skuvariants[i]);

		
		// 	for (var j=0; j<templateTags.length; j++){
		// 		//For each template tag.... drill through skuvariant templatenodes!
		// 		for (var key in localstate.skuvariants[i]) {
		// 			var skucomponent = localstate.skuvariants[i][key]; // The actual object (COA, Webcam, etc.)
		// 			// console.log(key); // e.g., "COA"
		// 			// console.log(skucomponent); // The full object
				  
		// 			// Loop through templatenodes array if it exists
		// 			if (skucomponent.templatenodes) {
		// 			  for (var l = 0; l < skucomponent.templatenodes.length; l++) {
		// 				var templatenode = skucomponent.templatenodes[l];
		// 				//console.log(templatenode.TemplateTag);
		// 				if (templatenode.TemplateTag === templateTags[j]){
		// 					currenttemplate = currenttemplate.replace(templateTags[j], templatenode.TemplateValue);
		// 					// console.log("#################################");
		// 					// console.log(templatenode.TemplateValue);
		// 				}
		// 			  }
		// 			}
		// 		  }
		// 	}

		// 	//Save currenttemplate to current skuvariant!
		// 	localstate.skuvariants[i].template = cloneDeep(currenttemplate);
		// }

		// console.log(localstate.skuvariants);

		//console.log(descriptiontemplate);

		// if (genmethod==="copy"){
		// 	navigator.clipboard.writeText(localstate.skuvariants[0].template);
		// }

	}


	const CopyDescription = (variantindex) => {
		var currentdescription = GenerateDescription(variantindex);
		navigator.clipboard.writeText(currentdescription);
	}


	// //Variant:
	// //Variant Buttons
	// const ToggleVariant = (variantindex) =>{
	// 	if (localstate.itemdata.product.productvariants[variantindex].Selected){
	// 		localstate.itemdata.product.productvariants[variantindex].Selected = false;
	// 		variantRefs.current[variantindex].classList.remove(classes.productvariant);
	// 		variantRefs.current[variantindex].classList.add(classes.productvariantunselected);
	// 	} else {
	// 		localstate.itemdata.product.productvariants[variantindex].Selected = true;
	// 		variantRefs.current[variantindex].classList.add(classes.productvariant);
	// 		variantRefs.current[variantindex].classList.remove(classes.productvariantunselected);
	// 	}

	// 	CalculateVariants();
		
	// }

	const ToggleVariant = (variantindex) => {
		setState(prev => {
		  const product = prev.itemdata?.product;
		  if (!product?.productvariants) return prev;
	  
		  return {
			...prev,
			itemdata: {
			  ...prev.itemdata,
			  product: {
				...product,
				productvariants: product.productvariants.map((v, i) =>
				  i === variantindex ? { ...v, Selected: !v.Selected } : v
				),
			  },
			},
		  };
		});
	  };



	/* 
																							 
		 _/_/_/        _/_/_/_/       _/      _/       _/_/_/        _/_/_/_/       _/_/_/    
		_/    _/      _/             _/_/    _/       _/    _/      _/             _/    _/   
	   _/_/_/        _/_/_/         _/  _/  _/       _/    _/      _/_/_/         _/_/_/      
	  _/    _/      _/             _/    _/_/       _/    _/      _/             _/    _/     
	 _/    _/      _/_/_/_/       _/      _/       _/_/_/        _/_/_/_/       _/    _/      
																						 
																						 
	  */
	/* ##########################  Render Function  ########################## */
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			{(!localstate.dbreload) &&
			<div style={{ padding: "8px", textAlign: "center", margin: "auto", marginBottom: "100px", overflow: "auto", maxWidth: "1200px", paddingBottom: "200px" }} ref={printRef}>

				{/* Standard Page Header with right floated error message space */}
				<div style={{ position: "relative", paddingTop: "5px", paddingBottom: "25px", minWidth: "750px" }}>
					<div style={{ textAlign: "center" }}>
						<h2>Listing Builder</h2>
					</div>
					<Box sx={{ displayPrint: 'none', height: "26px", display: "block" }}>
						<NewErrorMessage />
					</Box>
					<Button
							className={classes.bluebtn}
							color="primary" variant="contained"
							onClick={() => GoToListings()}>
							<KeyboardBackspaceIcon sx={{ color: "lightgray" }}></KeyboardBackspaceIcon>&nbsp;Back to Templates
						</Button>
					<Button
						className={(userPerms.updateListingTemplate === 1 && !localstate.auditview) ? classes.bluebtn : classes.hidden}
						color="primary" variant="contained"
						onClick={() => SaveChanges()}
						ref={el => btnSave.current = el}>
						<SaveIcon sx={{ color: "lightgray" }}></SaveIcon>&nbsp;Save Changes
					</Button>
					<Button
						className={(userPerms.updateListingTemplate === 1 || userPerms.createListingTemplate === 1) && !localstate.auditview ? classes.bluebtn : classes.hidden}
						color="primary" variant="contained"
						style={{ display: "none" }}
						onClick={() => SaveChanges()}
						ref={el => btnPendingSave.current = el}>
						<PendingIcon sx={{ color: "orange" }}></PendingIcon>&nbsp;Save Changes
					</Button>

					{/* <Button
						className={classes.bluebtn}
						color="primary" variant="contained"
						onClick={() => GenerateListings("copy")}
						>
						<ContentCopyIcon sx={{ color: "lightgray" }}></ContentCopyIcon>&nbsp;Generate Listing
					</Button> */}

					{/* <Button
						className={classes.bluebtn}
						color="primary" variant="contained"
						onClick={() => GenerateListings("download")}
						>
						<DownloadingIcon sx={{ color: "lightgray" }}></DownloadingIcon>&nbsp;Download Listings
					</Button> */}

				</div>
				<Box sx={{ display: "block", marginBottom: "20px", textAlign:"left" }}>
					<Typography variant="p">
						At the moment, this program will only generate the description content for the first sku generated in Sku Variants. 
						Adjust the appropriate Product Variants for each listing and generate them one by one.
					</Typography>
				</Box>


				<Typography variant="h6">
					<Grid container spacing={0}>
						<div className={classes.itemtableheader} style={{ display: "flex" }}>
							<div style={{ flexGrow: 1 }}><h3>Template Details</h3></div>
						</div>

						<Grid item sm={12} md={6}>
							<div className={classes.flextabledebug}>
								<table className={classes.itemtable}>
									<tbody>
										<tr>
											<td style={{ width: "160px" }}>
												Template Name:
											</td>
											<td>
												<input className={classes.flexiteminput}
													maxLength="100" //Needs max length
													type="text"
													value={localstate.itemdata.Name}
													onChange={(event) => onChangeValue(event, "Name")}
												/>
											</td>
										</tr>
										<tr>
											<td>
												Product:
											</td>
											<td>
												<DBAutoComplete
													key={localstate.productselectionkey}
													keyedby="ID"
													searchtype="products"
													searchkey="Name"
													itemindex={"productindex"} //Unused, but we'll set it anyway so it can be used by DBautocomplete
													defaultsearchterm={(localstate.itemdata.product ? localstate.itemdata.product.Name : "")}
													limit="100"
													errors={errors}
													allowadd={false}
													freeSolo={false}
													endadornment={(localstate.itemdata.product ?
														<div style={{ textAlign: "right", display: "inline-block" }}>
															<a href={hostbase + "/product/" + localstate.itemdata.product.ProductID} target="_blank">
																<OpenInNewIcon className={classes.transparenticon} color="primary" fontSize="medium">
																</OpenInNewIcon>
															</a>
															<a href={hostbase + "/inventorymanager?ProductID=" + encodeURIComponent(localstate.itemdata.product.ProductID) + "&ProductName=" + encodeURIComponent(localstate.itemdata.product.Name)} target="_blank">
																<ViewListIcon className={classes.transparenticon} color="primary" fontSize="medium">
																</ViewListIcon>
															</a>
														</div> : false)
													}
													endadornmentsize={"45px"}
													onDBAutoCompleteChange={onDBAutoCompleteChange}
												/>
											</td>
										</tr>
										<tr>
											<td>
												Sku Delimiter:
											</td>
											<td>
												<FormControl variant="standard" className={classes.flexitembasicselect} sx={{ m: 0, width: "100%", border: "0px" }}>
													<Select
														variant="standard"
														defaultValue={localstate.itemdata.SkuDelimiter}
														displayEmpty
														onChange={(event) => onChangeValue(event, "SkuDelimiter")}
														//Setting value means React will try to consider this a controlled component.
														//If you don't set a default value in state (before DB load), it will try to evaluate an undefined value and switch back to uncontrolled.
														//This will present an error when the component tries to go back to controlled.
														renderValue={
															(selected) => {
																return <Typography variant="h6">{localstate.itemdata.SkuDelimiter}</Typography>;
															}
														}
													>
														<MenuItem value={""}>No Delimiter</MenuItem>
														<MenuItem value={"-"}>-</MenuItem>
														<MenuItem value={":"}>:</MenuItem>
														<MenuItem value={"."}>.</MenuItem>
													</Select>
												</FormControl>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							</Grid>
							<Grid item sm={12} md={6}>
								<div className={classes.flextabledebug}>
									<table className={classes.itemtable}>
										<tbody>
											<tr>
												<td style={{ width: "230px", paddingTop: "8px" }}>
													Save As New Template:
												</td>
												<td style={{ verticalAlign: "bottom", paddingBottom: "4px" }}>
													<Checkbox
														checked={createnewitem}
														className={classes.gridcheckbox}
														onClick={() => toggleCreateNewItem()} />
												</td>
											</tr>
											<tr>
												<td style={{ width: "230px", paddingTop: "8px" }}>
													Delete Item:
												</td>
												<td style={{ verticalAlign: "bottom", paddingBottom: "4px" }}>
													<Checkbox
														checked={deleteitem}
														className={classes.gridcheckbox}
														onClick={() => markForDelete()} />
												</td>
											</tr>
										</tbody>
									</table>
								</div>
						</Grid>

						<Grid item sm={12} md={12}>
						<table className={classes.itemtable} style={{marginTop:"0px"}}>
									<tbody>
									<tr>
										<td style={{width:"160px"}}>
											Sku Structure:
										</td>
										<td>
											<input className={classes.flexiteminput}
												maxLength="255" //Needs max length
												type="text"
												defaultValue={localstate.itemdata.SkuStructure}
												onChange={(event) => onChangeValue(event, "SkuStructure")}
											/>							
										</td>
									</tr>
										<tr>
										<td style={{width:"160px"}}>
											Title Structure:
										</td>
										<td>
											<TextareaAutosize
												className={classes.flexiteminput}
												defaultValue={localstate.itemdata.TitleStructure}
												onChange={(event) => onChangeValue(event, "TitleStructure")}
												aria-label="Head \ HTML"
												placeholder="Title Structure"
												style={{ width: "100%" }}
											/>			
										</td>
									</tr>
									</tbody>
								</table>


						</Grid>


					</Grid>






					{/* Variant Components Selection */}

					<Grid container spacing={0}>
						<div className={classes.itemtableheader} style={{ display: "flex" }}>
							<div style={{ flexGrow: 1 }}><h3>Product Variants</h3></div>
							<div style={{ flexGrow: 1, textAlign: "right", paddingRight: "5px" }}>Variant Count: {localstate.variantcount}</div>
						</div>

						<Grid item sm={12} md={12}>
							<div className={classes.flextabledebug}>
								<table className={classes.itemtable}>
									<tbody>
										<tr>
											<td style={{ width: "160px" }}>
												Variants:
											</td>
											<td>
												{localstate.itemdata.product?.productvariants?.length > 0 &&
													localstate.itemdata.product.productvariants.map((productvariant, variantindex) => {
														//variantRefs.current[variantindex] = React.createRef();
														return (
															<div key={"variant"+variantindex} ref={el => variantRefs.current[variantindex] = el} 
																onClick={()=>{ToggleVariant(variantindex)}} 
																style={{ fontSize: "14px" }}
																// className={
																// (productvariant.Selected ? (classes.productvariant + " " + classes.hoverunit+ " "+classes.unselectable) : (classes.productvariantunselected + " " + classes.hoverunit))}
																className={
																	productvariant.Selected
																	  ? `${classes.productvariant} ${classes.hoverunit} ${classes.unselectable}`
																	  : `${classes.productvariantunselected} ${classes.hoverunit}`
																  }
																
																
																>
																{productvariant.details.Name}
																

																	&nbsp;&nbsp;
																<a href={hostbase + "/component/" + productvariant.ComponentID} target="_blank">
																						<OpenInNewIcon sx={{color:"white", fontSize:"14px"}}>
																						</OpenInNewIcon>
																					</a>
															</div>
														)
														
													})
												}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</Grid>
					</Grid>


					{/* Skus */}

					<Grid container spacing={0}>
						<div className={classes.itemtableheader} style={{ display: "flex" }}>
							<div style={{ flexGrow: 1 }}><h3>Skus</h3></div>
						</div>

						<Grid item sm={12} md={12}>
							<div className={classes.flextabledebug}>
								<table className={classes.itemtable}>
									<tbody>
										<tr>
											<td style={{ width: "160px" }}>
												Sku Variants:
											</td>
											<td>

													
											{(localstate.skuvariants && localstate.skuvariants.length > 0) &&
													localstate.skuvariants.map((skuvariant, variantindex) => {
														//variantRefs.current[variantindex] = React.createRef();
														return (
															<div key={"skuvariant" + variantindex} style={skuvariant.Found ? { color: "green" } : { color: "red" }}>{skuvariant.SKU}
															&nbsp;&nbsp;
															<a title="Copy Description" className={classes.hoverunit} onClick={() => CopyDescription(variantindex)}
																>
																	<ContentCopyIcon sx={{ color: "lightgray" }}></ContentCopyIcon>
																</a>
															</div>
														)
														
													})
												}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</Grid>
					</Grid>





				</Typography>

				<br></br>

				{/* ################################### ELEMENT BLOCKS ###################################  */}


				{/*
					1. Head (Head \ HTML) - Written HTML to help load fonts, css, create a container with a simple logo header, 
					and a place in which to insert our remaining content. We will let the user know they can insert the remaining 
					elements inside of ${content}. This is the ONLY element we aren't using our Quill Editor. We might toy with a 
					table generating mini-app for specifications?
					2. Header - Potential introduction of company, feature our value-added services, or quick links.
					3. TitleAndText - Large title of the product, text below with the most useful hooks.
					4. .... Etc.
				*/}


				<div className={classes.itemtableheader} style={{ display: "flex" }}>
					<div style={{ flexGrow: 1 }}><h3>Description Template</h3></div>
					<div style={{float:"right"}}>
						<Button
							ref={el => btnAddElement.current = el}
							className={classes.bluebtn}
							style={{marginTop:"0px"}}
							color="primary" variant="contained"
							aria-haspopup="true"
							onClick={ShowAddElementMenu}>
							Add Element
						</Button>

						<Menu
							className={classes.bluebtn}
							color="primary"
							id="view-options-menu"
							anchorEl={showAddElementMenu}
							keepMounted
							open={Boolean(showAddElementMenu)}
							onClose={CloseAddElementMenu}
						>

							{templateelements.map((templateelement, templateindex) => {
								if (!localstate.itemdata[templateelement.Name] && templateelement.menuoption) {
									return (
										<MenuItem key={templateindex} onClick={() => AddElement(templateelement.Name)}>{templateelement.Title}</MenuItem>
									);
								}
							})}
						</Menu>
					</div>
				</div>
				

				{(localstate.templateloaded || localstate.itemdata.PendingItem === 1) &&
					<div style={{ position: "relative" }} className={classes.isolatedcontainer}>

						{templateelements.map((templateelement, templateindex) => {
							if (localstate.itemdata[templateelement.Name] !== null || currenteditor.Name === templateelement.Name) {
								return (
									<div style={GetElementWidth(templateelement, templateindex)} key={templateindex}>
										{/* Handle 'editor' type of template elements */}
										{(templateelement.TemplateType === "html") &&
											<>	
											<div style={{ fontSize: "12px", textAlign:"left" }}>
												<b>HEAD\HTML Note:</b> You may apply all remaining template elements inside a &#36;&#123;CONTENT&#125; tag.
												 Otherwise if &#36;&#123;CONTENT&#125; tag is not found, HTML generated from the remaining elements will simply be concatenated with any HEAD\HTML element.</div>
											
												<TextareaAutosize
													style={{ minHeight: "50px", backgroundColor: "#EEE", width: "100%" }}
													className={classes.flexiteminput}
													defaultValue={localstate.itemdata[templateelement.Name]}
													onChange={(event) => ChangeHTML(event)}
													aria-label="Head \ HTML"
													placeholder="Enter markup here"
												/>

											</>
										}
										{(templateelement.TemplateType === "editor") &&
											<>
												{(currenteditor.Name === templateelement.Name) &&
												
													<TipTapEditor content={localstate.itemdata[templateelement.Name]} />
												}

												{/* Overlay a div on top of the static content for clickable */}
												{(currenteditor.Name !== templateelement.Name && localstate.itemdata[templateelement.Name] !== null) &&
													<div style={{ position: "relative" }}>
														<div className={classes.listingbuildersection} onClick={() => {
															if (currenteditor.Name !== templateelement.Name) {
																setCurrentEditor({
																	Name: templateelement.Name
																});
															}
														}}>
																<div style={{float:"right"}}>
																<CleaningServicesIcon className={classes.hoverunit} onClick={()=>{SweepValue(templateelement.Name)}} />
															</div>
															<span className={classes.hoverunit} style={{textDecoration:"underline"}}>{templateelement.Title} Section<br></br></span>
																<span style={{ fontSize: "15px" }}>{templateelement.Introduction}</span>
															
														</div>
														<div className={classes.isolatedcontainer} dangerouslySetInnerHTML={{ __html: localstate.itemdata[templateelement.Name] }} />
													</div>
												}
											</>
										}

										{/* Handle 'image' types of template elements */}
										{(templateelement.TemplateType === "image") &&
											<div style={{ border: "1px solid #CCC", minHeight: "100px", display: "inline-block", verticalAlign: "top", position: "relative", width: "100%" }}>
												<div style={{ position: "absolute", top: "10px", right: "10px" }}>
													<IconButton onClick={() => deleteElement(templateelement.Name)} color="inherit" sx={{
														backgroundColor: "#FFF", '&:hover': {
															backgroundColor: "rgba(255, 255, 255, 0.8)",
															boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
															transform: "scale(1.1)"
														},
														transition: "all 0.3s ease"
													}}>
														<DeleteIcon />
													</IconButton>
												</div>

												<div style={{ textAlign: "center", padding: "10px", paddingTop:"60px" }}>
													<ImageUpload templateelement={templateelement} />
												</div>
											</div>
										}


									</div>
								)
							}
						})}



					</div>
				}
			</div>
			}
			

		</LocalizationProvider >
	)
}

export default ListingBuilder;
